import * as React from "react";
import { FieldRow, FieldsTable } from "@/components/molecules/FieldsTable";
import { Responsible } from "./Responsible";
import { readableAccountNextSteps } from "@/utils/accounts";
import { AccountDisplayInfo } from "./AccountDetails";

export const MobileAccount: React.FC<AccountDisplayInfo> = ({
  persons,
  account: { serviceProviderType, phoneNumber, nextSteps, responsibleId },
}) => {
  return (
    <FieldsTable>
      <FieldRow label="Mobile number" value={phoneNumber} />

      <FieldRow
        label="Next Step"
        value={readableAccountNextSteps(nextSteps, serviceProviderType)}
      />

      <FieldRow
        label="Responsible"
        value={<Responsible persons={persons} responsibleId={responsibleId} />}
      />
    </FieldsTable>
  );
};
